import React, { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";

import Slider from "react-slick";
import { BrowserView, MobileView } from 'react-device-detect';

const Planificacion_recursos = 'https://cdn.redinet.us/Home/Planificacion_recursos.webp';
const Soluciones_analiticas = 'https://cdn.redinet.us/Home/Soluciones_analiticas.webp';
const IA_machine_learning = 'https://cdn.redinet.us/Home/IA_machine_learning.webp';
const Seguridad_disponibilidad = 'https://cdn.redinet.us/Home/Seguridad_disponibilidad.webp';
const Migracion_modernizacion = 'https://cdn.redinet.us/Home/Migracion_modernizacion.webp';
const planificacion_icon = 'https://cdn.redinet.us/Home/1. Planificación.webp';
const soluciones_icon = 'https://cdn.redinet.us/Home/2. Soluciones.webp';
const ai_icon = 'https://cdn.redinet.us/Home/3. AI.webp';
const seguridad_icon = 'https://cdn.redinet.us/Home/4. Seguridad.webp';
const migracion_icon = 'https://cdn.redinet.us/Home/5. Migración.webp';



const SolutionsComp = props => {
    const [t, i18n] = useTranslation('common');
    // Estado inicial basado en idioma actual (evitando texto hardcode en español)
    const [ObjSolution, setObj] = useState({
        title: t('oursolutions.Solution1'),
        src2: Planificacion_recursos,
        text: t('oursolutions.Descrp1'),
        css: 'mt-2 fade-in'
    });
    // Bandera para no sobrescribir la elección del usuario después del primer click
    const [userSelected, setUserSelected] = useState(false);

    // Cuando cambia el idioma y el usuario aún no ha seleccionado manualmente, actualizamos el contenido mostrado
    useEffect(() => {
        if (!userSelected) {
            setObj(prev => ({
                ...prev,
                title: t('oursolutions.Solution1'),
                text: t('oursolutions.Descrp1')
            }));
        }
    }, [i18n.language, t, userSelected]);

    const Solutions = [
        { src: planificacion_icon, alt: "Solucion1", src2: Planificacion_recursos, Id: 1, title: `${t('oursolutions.Solution1')}`, descrp: `${t('oursolutions.Descrp1')}`, css: "mt-2 fade-in" },
        { src: soluciones_icon, alt: "Solucion2", src2: Soluciones_analiticas, Id: 2, title: `${t('oursolutions.Solution2')}`, descrp: `${t('oursolutions.Descrp2')}`, css: "mt-2 fade-in" },
        { src: ai_icon, alt: "Solucion3", src2: IA_machine_learning, Id: 3, title: `${t('oursolutions.Solution3')}`, descrp: `${t('oursolutions.Descrp3')}`, css: "mt-2 fade-in" },
        { src: seguridad_icon, alt: "Solucion4", src2: Seguridad_disponibilidad, Id: 4, title: `${t('oursolutions.Solution4')}`, descrp: `${t('oursolutions.Descrp4')}`, css: "mt-2 fade-in" },
        { src: migracion_icon, alt: "Solucion5", src2: Migracion_modernizacion, Id: 5, title: `${t('oursolutions.Solution5')}`, descrp: `${t('oursolutions.Descrp5')}`, css: "mt-2 fade-in" }
    ];

    const ListSolutions = Solutions.map((item) =>
        <div className="p-2 flex-fill" key={item.Id} onClick={e => {
            setObj({
                title: item.title,
                text: item.descrp,
                css: item.css,
                src2: item.src2
            });
            if (!userSelected) setUserSelected(true);
        }}>
            <div className='card p-1 cursor-p'>
                <div className='container text-center mt-3' onMouseEnter={(e) => { handleEnterGiro(e) }} onMouseLeave={(e) => { handleLeaveGiro(e) }}>
                    <img src={item.src} className='img-giro w-50'></img>
                </div>
                <div className='container text-center mt-3'>
                    <h2 className='title-a-section-home our-alianza fz-20'>{item.title}</h2>
                </div>
            </div>
        </div>
    )

    const ListSolutionsMobile = Solutions.map((item) =>
        <div className="container" key={item.Id} onClick={e => {
            setObj({
                title: item.title,
                text: item.descrp,
                css: item.css,
                src2: item.src2
            });
            if (!userSelected) setUserSelected(true);
        }}>
            <div className='card'>
                <div className='container text-center mt-3'>
                    <h2 className='title-a-section-home fz-15'>{item.title}</h2>
                </div>
            </div>
        </div>
    )

    const handleEnterGiro = (e) => {

        if (e.target.children.length > 0) {
            e.target.children[0].classList.add('anima');
            e.target.children[0].classList.remove('anima-return');
        } else {
            e.target.classList.add('anima');
            e.target.classList.remove('anima-return');

        }
    }
    const handleLeaveGiro = (e) => {

        if (e.target.children.length > 0) {
            e.target.children[0].classList.add('anima-return');
            e.target.children[0].classList.remove('anima');
        } else {
            e.target.classList.add('anima-return');
            e.target.classList.remove('anima');

        }
    }

    const settings = {
        dots: true,
        infinite: true,
        speed: 0,
        slidesToShow: 2,
        slidesToScroll: 2
    };
    return (
        <div>
            <BrowserView>
                <div className='bg-gray'>
                    <div className="bg-white container-snake-left-rr_6">
                        <div className="container text-center padding-" >
                            <h2 className='title-a-section-home our-alianza'>{t('oursolutions.title')}</h2>
                            <p className='card-service-desc'>{t('oursolutions.descrp')}</p>
                        </div>
                        <div className=''>
                            <div className="d-flex">
                                {ListSolutions}
                            </div>
                        </div>
                        <div className={ObjSolution.css}>
                            <div className='d-flex pb-6'>
                                <div className='p-2 flex-fill image-cover' style={{ backgroundImage: `url(${ObjSolution.src2})` }}></div>
                                <div className='p-2 flex-fill p-3 section-text-solutions'>
                                    <h2 className='title-a-section-home our-alianza'>{ObjSolution.title}</h2>
                                    <br />
                                    <p className=''>{ObjSolution.text}</p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </BrowserView>
            <MobileView>
                <div className='bg-gray'>
                    <div className="bg-white container-snake-left-rr_">
                        <div className="text-center padding-" >
                            <Slider {...settings}>
                                {ListSolutionsMobile}
                            </Slider>
                            <div className={ObjSolution.css}>
                                <div className='d-flex flex-column'>
                                    <div className='p-2 flex-fill image-cover-mobile' style={{ backgroundImage: `url(${ObjSolution.src2})` }}></div>
                                    <div className='p-2 flex-fill p-3'>
                                        <h2 className='title-a-section-home our-alianza fz-28'>{ObjSolution.title}</h2>
                                        <br />
                                        <p className=''>{ObjSolution.text}</p>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </MobileView>


        </div>

    )
}


export default SolutionsComp